module.exports = __webpack_public_path__ + "static/media/prop-5.73240371.webp";